import { useEffect, useState } from "react";
import { SAFETY_PHRASES } from "../constants/safetyPhrases";

type Props = {
  open: boolean;
  onClose: () => void;
};

export function SafetyLoadModal({ open, onClose }: Props) {
  const [phraseIndex] = useState(() =>
    Math.floor(Math.random() * SAFETY_PHRASES.length),
  );

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="safety-load-title"
    >
      <div
        className="absolute inset-0 bg-black/80 backdrop-blur-md"
        aria-hidden
      />

      <div className="relative w-full max-w-lg rounded-2xl border border-emerald-500/25 bg-gradient-to-b from-zinc-900/98 via-zinc-950/99 to-black/95 p-6 sm:p-8 shadow-[0_0_0_1px_rgba(16,185,129,0.12),0_25px_80px_-20px_rgba(0,0,0,0.85)]">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500/20 to-emerald-700/10 text-emerald-400 ring-1 ring-emerald-400/30 shadow-[0_0_32px_-8px_rgba(52,211,153,0.5)]">
          <i className="ri-shield-check-line text-3xl" aria-hidden />
        </div>

        <p className="text-center text-[10px] font-black uppercase tracking-[0.35em] text-amber-500/90">
          Bienvenido
        </p>
        <h2
          id="safety-load-title"
          className="mt-2 text-center text-xl sm:text-2xl font-black text-white tracking-tight"
        >
          Seguridad responsable
        </h2>
        <p className="mt-1 text-center text-xs text-zinc-500 font-medium">
          Un recordatorio antes de explorar el sitio
        </p>

        <div className="mt-6 rounded-xl border border-white/5 bg-black/40 px-4 py-4 text-left">
          <p className="text-sm sm:text-base leading-relaxed text-zinc-200">
            <span className="font-semibold text-emerald-400/95">
              Seguridad:{" "}
            </span>
            {SAFETY_PHRASES[phraseIndex]}
          </p>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="mt-8 w-full rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 py-3.5 text-center text-sm font-black uppercase tracking-[0.2em] text-black shadow-lg shadow-amber-500/25 transition hover:from-amber-400 hover:to-amber-500 active:scale-[0.98]"
        >
          Continuar al sitio
        </button>
        <p className="mt-3 text-center text-[10px] text-zinc-600">
          Armería AK-47 — uso legal y responsable del armamento
        </p>
      </div>
    </div>
  );
}
